import { render, staticRenderFns } from "./modalReferensiPpjk.vue?vue&type=template&id=1e6e49cd&"
import script from "./modalReferensiPpjk.vue?vue&type=script&lang=js&"
export * from "./modalReferensiPpjk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports